import PropTypes from 'prop-types';

import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';
import {
  BrandDefaultProps,
  BrandPropTypes,
} from '@/common/proptypes/Common/Brand/Brand.proptypes';
import {
  FlagsDefaultProps,
  FlagsPropTypes,
} from '@/common/proptypes/Common/Flags/Flags.proptypes';
import {
  ImageDefaultProps,
  ImagePropTypes,
} from '@/common/proptypes/Common/Image/Image.proptypes';

export const CartItemDefaultProps = {
  ...BaseDefaultProps,
  ...BrandDefaultProps,
  ...FlagsDefaultProps,
  ...ImageDefaultProps,
  agrementFgaz: null,
  companyAvailability: false,
  delayQuantity: null,
  discountClass: null,
  discountClasses: [],
  discountLabel: null,
  discountPriceItem: null,
  hasPrice: true,
  hasStock: true,
  id: null,
  invoiceUnit: null,
  isSalable: false,
  isSelected: false,
  isSubstitute: false,
  lineSubtotal: null,
  mainSku: null,
  manufacturerSku: null,
  mustSubstitute: false,
  name: null,
  price: null,
  quantity: null,
  quoteNumber: null,
  saleUnit: null,
  salesPackaging: null,
  sku: null,
  splitPackaging: false,
  stockStatus: null,
  stocks: [],
  substitute: null,
  weeeAmount: null,
  weeeTotalAmount: null,
};

export const CartItemPropTypes = {
  ...BasePropTypes,
  ...BrandPropTypes,
  ...FlagsPropTypes,
  ...ImagePropTypes,
  agrementFgaz: PropTypes.string,
  companyAvailability: PropTypes.bool,
  delayQuantity: PropTypes.number,
  discountClass: PropTypes.string,
  discountClasses: PropTypes.arrayOf(PropTypes.shape({})),
  discountLabel: PropTypes.string,
  discountPriceItem: PropTypes.number,
  hasPrice: PropTypes.bool,
  hasStock: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  invoiceUnit: PropTypes.string,
  isSalable: PropTypes.bool,
  isSelected: PropTypes.bool,
  isSubstitute: PropTypes.bool,
  lineSubtotal: PropTypes.number,
  mainSku: PropTypes.string,
  manufacturerSku: PropTypes.string,
  mustSubstitute: PropTypes.bool,
  name: PropTypes.string,
  onModify: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  price: PropTypes.number,
  quantity: PropTypes.number,
  quoteNumber: PropTypes.number,
  saleUnit: PropTypes.string,
  salesPackaging: PropTypes.number,
  sku: PropTypes.string,
  splitPackaging: PropTypes.bool,
  stockStatus: PropTypes.string,
  stocks: PropTypes.arrayOf(PropTypes.shape({})),
  substitute: PropTypes.string,
  weeeAmount: PropTypes.number,
  weeeTotalAmount: PropTypes.number,
};
